import { ModelBasic } from '../core';

export interface CourseMessage extends ModelBasic {
  message_type: string;
  title: string;
  content: string;
  priority: string;
  needs_reading_confirmation: boolean;
  reading_confirmation_text: string;
}

export interface CourseCustomer extends ModelBasic {
  first_name: string;
  last_name: string;
  full_name: string;
  email: string;
  birthday: string;
  street: string;
  housenumber: string;
  zip_code: string;
  city: string;
  country?: Country;
  latitude: number;
  longitude: number;
}

export interface Country extends ModelBasic {
  country: string;
  country_code: string;
}
